var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.2488V15.75C0 16.991 3.02344 18 6.75 18C10.4766 18 13.5 16.991 13.5 15.75V14.2488C12.048 15.2719 9.39375 15.75 6.75 15.75C4.10625 15.75 1.45195 15.2719 0 14.2488ZM11.25 4.5C14.9766 4.5 18 3.49102 18 2.25C18 1.00898 14.9766 0 11.25 0C7.52344 0 4.5 1.00898 4.5 2.25C4.5 3.49102 7.52344 4.5 11.25 4.5ZM0 10.5609V12.375C0 13.616 3.02344 14.625 6.75 14.625C10.4766 14.625 13.5 13.616 13.5 12.375V10.5609C12.048 11.7562 9.39023 12.375 6.75 12.375C4.10977 12.375 1.45195 11.7562 0 10.5609ZM14.625 10.9477C16.6395 10.5574 18 9.8332 18 9V7.49883C17.1844 8.07539 15.9855 8.46914 14.625 8.71172V10.9477ZM6.75 5.625C3.02344 5.625 0 6.88359 0 8.4375C0 9.99141 3.02344 11.25 6.75 11.25C10.4766 11.25 13.5 9.99141 13.5 8.4375C13.5 6.88359 10.4766 5.625 6.75 5.625ZM14.4598 7.6043C16.5691 7.22461 18 6.4793 18 5.625V4.12383C16.752 5.00625 14.6074 5.48086 12.3504 5.59336C13.3875 6.09609 14.1504 6.77109 14.4598 7.6043Z",
    fill: "#503EB6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoins);
export default __webpack_public_path__ + "static/media/coins.fbc25a9f261b61cc12ad0f77c2895f6f.svg";
export { ForwardRef as ReactComponent };